import type { OrderQuote } from 'src/shared/types/quote';

/**
 * Derives the supplier cloak names to show as filter tabs on the Quotes tab.
 *
 * Only suppliers that contribute at least one visible table row (i.e. their
 * order quote has at least one product quote) are included, so selecting a
 * filter can never yield an empty table. Names are deduped and sorted
 * alphabetically (case-insensitive) so ordering is consistent across tabs.
 */
const getQuoteSupplierCloaks = (orderQuotes: OrderQuote[]): string[] => {
  const cloaks = (orderQuotes || [])
    .filter((orderQuote) => (orderQuote.product_quotes?.length ?? 0) > 0)
    .map((orderQuote) => orderQuote.supplier?.cloak)
    .filter((cloak): cloak is string => Boolean(cloak));

  return Array.from(new Set(cloaks)).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
};

export default getQuoteSupplierCloaks;
